module.exports = __webpack_public_path__ + "img/057-hiker-man-colour.07f81471.svg";